<span class="label" *ngIf="label">
    {{label}}
</span>

<ic-builder-signature istag="signature"
    [formControl]="formControl"
    (signatureCreated)="registerSignature($event)"
    [signPad]="signPad"
></ic-builder-signature>